import { TRITECNICA_BORDER_RADIUS, TRITECNICA_BOX_SHADOW, TRITECNICA_COLORS, TRITECNICA_FONTS, TRITECNICA_LAYOUT, TRITECNICA_SPACING, } from './tritecnicaThemeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
import { TRIOLIET_COLORS } from '../trioliet';
const tritecnicaThemeConf = {
    color: {
        primary: {
            lightest: TRITECNICA_COLORS.primary.lightest,
            light: TRITECNICA_COLORS.primary.light,
            main: TRITECNICA_COLORS.primary.main,
            dark: TRITECNICA_COLORS.primary.dark,
            darkest: TRITECNICA_COLORS.primary.darkest,
        },
        brand: {
            lightest: TRITECNICA_COLORS.brand.lightest,
            light: TRITECNICA_COLORS.brand.light,
            main: TRITECNICA_COLORS.brand.main,
            dark: TRITECNICA_COLORS.brand.dark,
            darkest: TRITECNICA_COLORS.brand.darkest,
        },
        success: {
            light: TRITECNICA_COLORS.success.light,
            main: TRITECNICA_COLORS.success.main,
            dark: TRITECNICA_COLORS.success.dark,
        },
        error: {
            lightest: TRITECNICA_COLORS.error.lightest,
            light: TRITECNICA_COLORS.error.light,
            main: TRITECNICA_COLORS.error.main,
            dark: TRITECNICA_COLORS.error.dark,
        },
        warning: {
            lightest: TRITECNICA_COLORS.warning.lightest,
            light: TRITECNICA_COLORS.warning.light,
            main: TRITECNICA_COLORS.warning.main,
        },
        grey: {
            lightest: TRITECNICA_COLORS.grey.lightest,
            light: TRITECNICA_COLORS.grey.light,
            default: TRITECNICA_COLORS.grey.default,
            dark: TRITECNICA_COLORS.grey.dark,
            darkest: TRITECNICA_COLORS.grey.darkest,
        },
        input: {
            placeholder: TRITECNICA_COLORS.grey.default,
            border: TRITECNICA_COLORS.grey.default,
        },
        background: {
            body: TRITECNICA_COLORS.background.body,
            light: TRITECNICA_COLORS.background.light,
            dark: TRITECNICA_COLORS.background.dark,
        },
        font: {
            dark: TRITECNICA_COLORS.font.dark,
            light: TRITECNICA_COLORS.font.light,
        },
        common: {
            contentHover: TRITECNICA_COLORS.common.contentHover,
        },
    },
    font: {
        family: TRITECNICA_FONTS.family,
        size: {
            small: TRITECNICA_FONTS.size.small,
            mediumSmall: TRITECNICA_FONTS.size.mediumSmall,
            medium: TRITECNICA_FONTS.size.medium,
            mediumBig: TRITECNICA_FONTS.size.mediumBig,
            big: TRITECNICA_FONTS.size.big,
            caption: TRITECNICA_FONTS.size.caption,
            title: TRITECNICA_FONTS.size.title,
            heading: TRITECNICA_FONTS.size.heading,
        },
        lineHeight: {
            small: TRITECNICA_FONTS.lineHeight.small,
            mediumSmall: TRITECNICA_FONTS.lineHeight.mediumSmall,
            medium: TRITECNICA_FONTS.lineHeight.medium,
            mediumBig: TRITECNICA_FONTS.lineHeight.mediumBig,
            big: TRITECNICA_FONTS.lineHeight.big,
        },
        weight: {
            light: TRITECNICA_FONTS.weight.light,
            normal: TRITECNICA_FONTS.weight.normal,
            bold: TRITECNICA_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: TRITECNICA_BORDER_RADIUS.low,
            default: TRITECNICA_BORDER_RADIUS.default,
            high: TRITECNICA_BORDER_RADIUS.high,
            onlyTop: TRITECNICA_BORDER_RADIUS.onlyTop,
            onlyRight: TRITECNICA_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: TRITECNICA_BOX_SHADOW.light,
            default: TRITECNICA_BOX_SHADOW.default,
            dark: TRITECNICA_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: TRITECNICA_SPACING.layout.fullWidth,
            partialWidth: TRITECNICA_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: TRITECNICA_SPACING.margin.smallest,
            small: TRITECNICA_SPACING.margin.small,
            default: TRITECNICA_SPACING.margin.default,
            large: TRITECNICA_SPACING.margin.large,
            largest: TRITECNICA_SPACING.margin.largest,
            horizontalDefault: TRITECNICA_SPACING.margin.horizontalDefault,
            verticalDefault: TRITECNICA_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: TRITECNICA_SPACING.padding.smallest,
            small: TRITECNICA_SPACING.padding.small,
            default: TRITECNICA_SPACING.padding.default,
            large: TRITECNICA_SPACING.padding.large,
            largest: TRITECNICA_SPACING.padding.largest,
            horizontalDefault: TRITECNICA_SPACING.padding.horizontalDefault,
            verticalDefault: TRITECNICA_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: TRITECNICA_LAYOUT.width.full,
            partial: TRITECNICA_LAYOUT.width.partial,
        },
        sidebar: {
            full: TRITECNICA_LAYOUT.sidebar.full,
        },
        header: {
            topBar: TRITECNICA_LAYOUT.header.topBar,
            menu: TRITECNICA_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: TRITECNICA_COLORS.primary.dark,
                color: TRITECNICA_COLORS.font.light,
            },
            headerSecondary: {
                background: TRITECNICA_COLORS.brand.main,
                color: TRITECNICA_COLORS.font.light,
            },
            th: {
                background: TRITECNICA_COLORS.background.light,
                color: TRITECNICA_COLORS.primary.dark,
            },
            row: {
                hover: TRITECNICA_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: TRITECNICA_COLORS.brand.main,
                hover: TRITECNICA_COLORS.brand.light,
            },
        },
        header: {
            colors: {
                background: TRITECNICA_COLORS.background.light,
                text: TRITECNICA_COLORS.font.dark,
                menuIcon: TRITECNICA_COLORS.font.dark,
            },
        },
        menu: {
            colors: {
                background: TRITECNICA_COLORS.background.light,
                text: TRITECNICA_COLORS.font.dark,
                selected: TRITECNICA_COLORS.primary.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: TRITECNICA_COLORS.primary.main,
                headerText: TRITECNICA_COLORS.font.light,
                buttonBackground: TRITECNICA_COLORS.background.light,
                buttonText: TRITECNICA_COLORS.font.dark,
                buttonBackgroundHover: TRITECNICA_COLORS.primary.main,
                triggerBackground: TRITECNICA_COLORS.primary.main,
                triggerText: TRITECNICA_COLORS.font.light,
                userIconBackground: TRITECNICA_COLORS.brand.main,
                userIconText: TRITECNICA_COLORS.font.light,
            },
        },
        tabs: {
            indicator: TRITECNICA_COLORS.brand.main,
            background: TRITECNICA_COLORS.primary.light,
            color: TRITECNICA_COLORS.brand.main,
        },
        listItem: {
            backgroundHover: TRITECNICA_COLORS.background.light,
            backgroundSelected: TRITECNICA_COLORS.primary.main,
            textHover: TRITECNICA_COLORS.font.dark,
            textSelected: TRITECNICA_COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: TRITECNICA_COLORS.primary.main,
                border: TRIOLIET_COLORS.primary.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: TRITECNICA_COLORS.background.light,
                text: TRITECNICA_COLORS.font.dark,
            },
            arrow: {
                background: TRITECNICA_COLORS.background.light,
            },
            rule: {
                iconSuccess: TRITECNICA_COLORS.success.main,
                iconError: TRITECNICA_COLORS.error.main,
                text: TRITECNICA_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: TRITECNICA_COLORS.brand.main,
            backgroundHover: TRITECNICA_COLORS.brand.light,
            text: TRITECNICA_COLORS.font.light,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: TRITECNICA_COLORS.primary.light,
                main: TRITECNICA_COLORS.primary.main,
                dark: TRITECNICA_COLORS.primary.dark,
            },
            secondary: {
                light: TRITECNICA_COLORS.brand.light,
                main: TRITECNICA_COLORS.brand.main,
                dark: TRITECNICA_COLORS.brand.dark,
            },
            text: {
                primary: TRITECNICA_COLORS.font.dark,
                secondary: TRITECNICA_COLORS.font.light,
            },
        },
        typography: {
            fontFamily: TRITECNICA_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: TRITECNICA_COLORS.font.dark,
                    fontSize: TRITECNICA_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: TRITECNICA_COLORS.grey.light,
                    '&$disabled': {
                        color: TRITECNICA_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: TRITECNICA_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: TRITECNICA_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: TRITECNICA_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${TRITECNICA_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: TRITECNICA_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: TRITECNICA_COLORS.font.light,
                        fontSize: TRITECNICA_FONTS.size.mediumSmall,
                        fontWeight: TRITECNICA_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${TRITECNICA_COLORS.primary.main} !important`,
                },
                active: {
                    color: `${TRITECNICA_COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: TRITECNICA_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: TRITECNICA_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const tritecnicaTheme = createMyTheme(tritecnicaThemeConf);
//# sourceMappingURL=tritecnicaTheme.js.map